<template>
  <el-form ref="form" :model="form" :rules="rules" label-width="120px">
    <el-form-item label="锁库数" prop="fLockQty">
      <el-input-currency v-model="form.fLockQty" />
    </el-form-item>
    <el-form-item label="锁库说明" prop="fLockDes">
      <el-input v-model="form.fLockDes" />
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  props: {
    form: Object
  },
  data: function() {
    return {
      rules: {
        fLockQty: [{ required: true, message: '必填项', trigger: 'change' }]
      }
    }
  },
  methods: {
    submit: function(onValid, onSuccess, onFailed, onComplete) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const data = Object.assign({}, this.form)
          onValid(data)
        } else {
          return false
        }
      })
    }

  }
}
</script>

<style>
</style>
